import { DOCK_LABELS } from "../../shared/constants/pageAgentLabels";
import type { ClearChatConfirmControls } from "../hooks/useClearChatConfirm";

interface ClearChatButtonProps {
  controls: ClearChatConfirmControls;
  /** False while a run is in flight, a clear is under way, or there is nothing to clear. */
  enabled: boolean;
}

/** "Clear chat" in the dock and page headers; opens the confirm prompt rather than clearing at once. */
export function ClearChatButton({ controls, enabled }: ClearChatButtonProps) {
  return (
    <button ref={controls.triggerRef} type="button" className="pa-button pa-button-secondary pa-button-small"
      disabled={!enabled} aria-expanded={controls.confirming} aria-controls={controls.confirming ? controls.promptId : undefined}
      onClick={controls.request}>
      {DOCK_LABELS.clearChat}
    </button>
  );
}
